var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraVideoDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 17.1346v-5.4019c0-1.7327-.9614-2.7327-2.7183-2.7327h-5.4246z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.42774 9.27733c-.88814.40893-1.42774 1.25687-1.42774 2.45537v8.5432c0 1.7241 1.04895 2.7241 2.80616 2.7241h9.38794c.9392 0 1.6761-.2858 2.1586-.8152z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m25.9492 22c-.8832 0-.9492 0-3.9492-4v-4c2.4075-3.21 2.883-3.844 3.4674-3.9692.1439-.0308.2943-.0308.4818-.0308.6353 0 1.0508.5189 1.0508 1.2656v9.469c0 .7465-.4155 1.2654-1.0508 1.2654z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.3837 27.7231c.3702.3692.9728.3692 1.343 0 .3585-.3819.3703-.9729 0-1.3425l-22.107-22.10339c-.36629-.36961-.96886-.36961-1.35089 0-.35841.36923-.35841.98513 0 1.34213z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraVideoDisabled);
export default __webpack_public_path__ + "static/media/Camera_Video-Disabled.0ed148dc348c0cc93bb6a030418d9549.svg";
export { ForwardRef as ReactComponent };